<template>
  <div>
    <b-modal
      @cancel="hideModal"
      no-close-on-backdrop
      ref="shopStocks"
      size="xl"
      :title="shop_info.name + ' ' + 'stocks'"
      hide-footer
    >
      <!--Stocks Filter -->
      <b-row style="margin-top: 1em">
        <b-col cols="4">
          <v-select
            v-model="selectedBrand"
            class="select_"
            :get-option-label="(option) => option.name"
            :options="brands"
            placeholder="Select Brand"
            @input="onChangeBrand"
          />
        </b-col>
        <b-col cols="4">
          <v-select
            v-model="selectedCategory"
            class="select_"
            :get-option-label="(option) => option.name"
            :options="categories"
            placeholder="Select Category"
            @input="onChangeCategory"
          />
        </b-col>
        <b-col cols="4">
          <input
            v-model="payload.query"
            type="string"
            class="form-control"
            placeholder="search"
            style="margin-bottom: 10px; border-radius: 10px"
            @input="fetchShopStocks"
          />
        </b-col>
      </b-row>
      <b-row class="pl-3 pr-3 text-center">
        <b-col v-if="shopsStocks.length < 1 && !loading">
          <b-alert show variant="warning">No Stock Found!</b-alert>
        </b-col>
      </b-row>

      <!-- stocks List -->
      <b-row v-if="loading" class="d-flex justify-content-center">
        <b-spinner
          style="width: 3rem; height: 3rem"
          variant="primary"
          label="Spinning"
        />
      </b-row>
      <b-row v-if="shopsStocks.length > 0 && !loading">
        <div cols="6" v-for="(item, index) in shopsStocks" :key="index">
          <b-col style="margin-bottom: 1rem">
            <div class="card cardFont">
              <b-row>
                <b-col cols="4"
                  ><p class="text-sm headerStyle" style="margin-top: 1rem">
                    {{ item.name }}
                  </p></b-col
                >
                <b-col cols="6" v-if="item.units == null"></b-col>
                <b-col cols="6" v-else style="margin-top: 0.5rem"
                  ><p>
                    {{ item.selectedUnit }}
                    <v-select
                      v-model="shopsStocksUnits[index]"
                      :get-option-label="(option) => option.name"
                      :options="item.units"
                      placeholder="Select Unit"
                      @input="onChangeUnit($event, item, index)"
                    />
                  </p>
                </b-col>
                <b-col cols="2">
                  <b-dropdown
                    variant="white"
                    size="md"
                    no-caret
                    right
                    id="popover-shop-sync"
                  >
                    <template #button-content>
                      <i
                        class="fa fa-money money-icon-btn"
                        aria-hidden="true"
                      ></i>
                    </template>
                    <div
                      v-if="
                        item.units == null || unitPayload.batch != item.batch.id
                      "
                      style="width: 240px"
                    >
                      <b-dropdown-text>
                        <div class="money-dropdown-font">
                          Purchase Price:{{ item.purchase_price | amount }}
                        </div>
                      </b-dropdown-text>
                      <b-dropdown-text>
                        <div class="money-dropdown-font">
                          Min Price:{{ item.min_price | amount }}
                        </div>
                      </b-dropdown-text>
                    </div>
                    <div v-else style="width: 240px">
                      <b-dropdown-text>
                        <div class="money-dropdown-font">
                          Purchase Price:{{ unitList.purchase_price | amount }}
                        </div>
                      </b-dropdown-text>
                      <b-dropdown-text>
                        <div class="money-dropdown-font">
                          Min Price:{{ unitList.min_price | amount }}
                        </div></b-dropdown-text
                      >
                    </div>
                  </b-dropdown>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="6">
                  <div style="margin-left: 1rem">
                    Brand : {{ item.brand }}<br />
                    Batch : {{ item.batch.batch }}<br />
                    Category : {{ item.category }}
                  </div>
                </b-col>
                <b-col cols="6" v-if="item.units == null">
                  Unit :{{ item.unit.name }}<br />
                  Quantity : {{ item.quantity }}<br />
                  Selling Price :{{ item.selling_price | amount }}<br />
                </b-col>
                <b-col cols="6" v-else>
                  <div v-if="unitPayload.batch != item.batch.id">
                    Unit :{{ item.unit.name }}<br />
                    Quantity : {{ item.quantity }}<br />
                    Selling Price : {{ item.selling_price | amount }}<br />
                  </div>
                  <div v-else-if="unitList == null">
                    Unit :{{ item.unit.name }}<br />
                    Quantity : {{ item.quantity }}<br />
                    Selling Price : {{ item.selling_price | amount }}<br />
                  </div>
                  <div v-else>
                    Unit :{{ shopsStocksUnits[index].name }}<br />
                    Quantity : {{ unitList.quantity }}<br />
                    Selling Price : {{ unitList.selling_price | amount }}<br />
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </div>
      </b-row>
      <!---------------->
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "ShopStock",
  components: {},

  methods: {
    moment: function (date) {
      return moment(date).format("LL");
    },
    async fetchShopStocks() {
      this.loading = true;
      this.payload.id = this.shop_info.id;
      this.payload.shop = this.shop_info.id;
      await this.$store
        .dispatch("shopStocks/shopStocks", this.payload)
        .then((res) => {
          this.loading = false;
          this.unitList = null;
          this.shopsStocksUnits = new Array(res.length);
        })
        .catch((err) => {
          this.loading = false;
          this.stocks = [];
        });
    },
    async fetchUnitDetails() {
      this.unitPayload.id = this.shop_info.id;

      await this.$store
        .dispatch("shopStocks/shopStocksUnit", this.unitPayload)
        .then((res) => {
          this.unitList = res;
        })
        .catch(async (err) => {
          this.unitList = null;
        });
    },
    onChangeBrand(value) {
      value ? (this.payload.brand = value.id) : (this.payload.brand = "");
      this.fetchShopStocks();
    },
    onChangeCategory(value) {
      value ? (this.payload.category = value.id) : (this.payload.category = "");
      this.fetchShopStocks();
    },
    onChangeUnit(event, value, index) {
      this.shopsStocksUnits = new Array(this.shopsStocks.length);
      this.shopsStocksUnits[index] = event;
      this.unitPayload.product_id = value.id;
      this.unitPayload.batch = value.batch.id;
      this.unitPayload.unit = value.unit.id;
      event === null
        ? (this.unitPayload.convertUnit = value.unit.id)
        : (this.unitPayload.convertUnit = event.id);
      this.fetchUnitDetails();
    },
    showModal() {
      (this.payload = {
        id: null,
        query: "",
        category: "",
        brand: "",
      }),
        (this.selectedBrand = null);
      this.selectedCategory = null;
      this.loading = true;
      this.fetchShopStocks();
      this.$refs["shopStocks"].show();

      this.loading = false;
    },
    hideModal() {
      this.$refs["shopStocks"].hide();
    },
  },
  props: {
    data: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data: () => ({
    unitList: null,
    selectedUnit: {
      id: null,
      name: null,
    },
    selectedBrand: null,
    selectedCategory: null,
    loading: false,
    query: null,
    payload: {
      id: null,
      query: "",
      category: "",
      brand: "",
    },
    unitPayload: {
      id: null,
      product_id: null,
      unit: "",
      batch: "",
      convertUnit: "",
    },
    shopsStocksUnits: [],
  }),
  computed: {
    ...mapState("shops", ["shop_info"]),
    ...mapState("product", ["brands"]),
    ...mapState("product", ["categories"]),
    ...mapState("shopStocks", ["shopsStocks"]),
  },
};
</script>
<style scoped>
.headerStyle {
  color: #20289e !important;
  font-size: 14px !important;
  line-height: 18px !important;
  margin-left: 20px !important;
}
.cardFont {
  border-radius: 20px !important;
  background: rgb(255, 255, 255);
  width: 33rem;
  height: 8rem;
  box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15) !important;
  font-family: Helvetica, Arial, sans-serif;
  font-weight: 700;
}
.money-btn {
  color: white !important;
}
.money-icon-btn {
  color: rgb(233, 62, 0);
}
.money-dropdown-font {
  color: black;
  font-family: Helvetica, Arial, sans-serif !important;
  font-weight: 700 !important;
}
</style>
